window._define('utils/font', ['jquery'], function ($) {
    'use strict';

    var deferred;

    function fontCheckerloaded(fontFamilyTest) {
        var startTime, timeout, $tester, intervalId, referenceWidth;

        if (!deferred) {
            startTime = Date.now();
            timeout = 5000;
            deferred = $.Deferred();
            $tester = $('<span>QW@HhsXJp|</span>').css({
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                'font-family': 'Comic Sans MS',
                fontSize: '250px',
            });

            $tester.appendTo('body');

            referenceWidth = $tester.outerWidth();

            $tester.css('font-family', fontFamilyTest + ', Comic Sans MS');

            intervalId = setInterval(function () {
                if (referenceWidth !== $tester.outerWidth() || (Date.now() - startTime > timeout)) {
                    clearInterval(intervalId);
                    deferred.resolve();
                }
            }, 50);
        }

        return deferred.promise();
    }

    return {
        loaded: fontCheckerloaded,
    };

});
